import React from 'react'

export default function Question({ question, selected, onSelect, index }) {
  const isMulti = Boolean(
    question?.multiSelect || (Array.isArray(question?.correctChoiceIds) && question.correctChoiceIds.length > 1)
  )

  const handleToggle = (choiceId) => {
    if (!isMulti) {
      onSelect(choiceId)
      return
    }
    const current = Array.isArray(selected) ? selected : []
    const exists = current.includes(choiceId)
    const next = exists ? current.filter((id) => id !== choiceId) : [...current, choiceId]
    onSelect(next)
  }

  return (
    <div className="tw:mb-6 tw:p-4 tw:border tw:border-gray-200 tw:rounded-sm">
      <div className="tw:font-medium tw:mb-3">{index + 1}. {question.text}</div>
      <div className="tw:space-y-2">
        {question.choices.map((choice) => (
          <label key={choice.id} className="tw:flex tw:items-center tw:space-x-2 tw:cursor-pointer">
            <input
              type={isMulti ? 'checkbox' : 'radio'}
              name={`q-${question.id}`}
              value={choice.id}
              checked={isMulti ? (Array.isArray(selected) && selected.includes(choice.id)) : selected === choice.id}
              onChange={() => handleToggle(choice.id)}
              className={isMulti ? 'tw:accent-blue-600 tw:h-4 tw:w-4' : 'tw:accent-blue-600 tw:h-4 tw:w-4'}
            />
            <span>{choice.text}</span>
          </label>
        ))}
      </div>
    </div>
  )
}
